<template>
  <div>
    <v-text-field
      :label="label"
      :variant="variant"
      :type="type"
      :hint="hint"
      :readonly="readonly"
      :disabled="disabled"
      :placeholder="placeholder"
      :prepend-inner-icon="prependIcon"
      :append-inner-icon="appendIcon"
      :suffix="suffix"
      :prefix="prefix"
      :value="defaultValue"
      @change="getVal"
      :dark="dark"
    >
    </v-text-field>
  </div>
</template>

<script>
export default {
  mounted() {
    this.model = this.defaultValue;
  },
  props: {
    label: {
      default: "Text Field",
    },
    dark: {
      default: false,
    },
    defaultValue: {
      default: "",
    },
    placeholder: {
      default: "",
    },
    hint: {
      default: "",
    },
    type: {
      default: "text",
    },
    variant: {
      default: "underlined",
    },
    readonly: {
      default: false,
    },
    disabled: {
      default: false,
    },
    prependIcon: {
      default: "",
    },
    appendIcon: {
      default: "",
    },
    suffix: {
      default: "",
    },
    prefix: {
      default: "",
    },
  },
  data: () => ({
    model: null,
  }),
  methods: {
    getVal(val) {
      this.$emit("input-updated", val);
    },
  },
};
</script>

<style></style>
